import { PageOptions } from "@/contexts/DashboardStateContext";

export const tabToPageOption: Record<string, PageOptions> = {
  schedules: "Schedules",
  visitors: "Visitors",
  news: "News",
  siteInfo: "SiteInfo"
};

export const pageOptionToTab: Record<PageOptions, string> = {
  Schedules: "schedules",
  Visitors: "visitors",
  News: "news",
  SiteInfo: "siteInfo"
};

export const DEFAULT_DAYS_COUNT = 5;
